import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import arrow_back from '../assets/images/arrow-back.svg';
import logo_pop from '../assets/images/logo-pop.png';
import ProfileHeader from '../components/ProfileHeader';
import { setStartDate, setGroups } from '../reducers/reposReducers';
import { useDispatch, useSelector } from 'react-redux';
import EDSFooter from '../components/EDSFooter';
import ApiService from '../services/ApiService';
import NotificationService from '../services/NotificationService';

const Wybor_opcji_2_data = () => {
    const key = useSelector((state) => state.repos.chName);
    if (!key || key == '') {
       
        history.push(`/LoginBuy/key=${localStorage.getItem('keyURL')}`);
    }
    let time = [];
    const dataSelecrCurse = useDispatch();
    const history = useHistory();
    const [selectedItem, setSelectedItem] = useState(0);
    let coursesHeadings = useSelector((state) => state.repos.coursesHeadings);
    if (coursesHeadings) {
        let timeArr = coursesHeadings.courseTime.split(',');
        timeArr.map((e, index) => {
            time.push({ key: index, name: e });
        });
    }
    const notificationService = NotificationService.getInstance();
    const [res, setRes] = useState(time);
    let users = useSelector((state) => state.repos.users);
    let usersParticipant = useSelector((state) => state.repos.usersParticipant);
    let dateToBay = useSelector((state) => state.repos.date);
    const today = new Date(dateToBay ? dateToBay : new Date());
    const date = today.setDate(today.getDate());
    const defaultValue = new Date(date).toISOString().split('T')[0]; // yyyy-mm-dd
    const [formData, setFromData] = useState({
        startDate: defaultValue,
    });
    const dispatch = useDispatch();
    const [disableButton, setdisableButton] = useState(false);
    const [formDataHeading] = useState({
        courseHeadingName: useSelector((state) => state.repos.chName), 
        attendanceStartDate: `${defaultValue}`,
        current_LocalizationsID: '0',
    });

    const [paramsUsers] = useState({
        purchaseKey: useSelector((state) => state.repos.chName),
        dateFrom: `${defaultValue}`,
        usersID: usersParticipant.usersID? usersParticipant.usersID: users.usersID,
        current_LocalizationsID: '0',
    });
 
    const apiService = ApiService.getInstance();

    function goNextStaps(e){
        apiService.asyncApiPost('CheckUserForPurchaseKey', paramsUsers).then((response) => {
            if(+response.body === 0){
                dataSelecrCurse(setStartDate(formData.startDate));
             
                localStorage.setItem('dateToBay', JSON.stringify(formData.startDate));
                e.preventDefault();
                localStorage.setItem('startDate', formData.startDate);
                history.push('/Wybor_opcji_3_wariant');
            } else if(+response.body > 0) {
                notificationService.showError('Uczestnik, dla którego tworzysz umowę, jest już zapisany na ten kurs. Skontaktuj się z BOK');  
            } else if (+response.body === -1){
                notificationService.showError('Tworzenie umowy jest w trakcie procesowania. Spróbuj ponownie za chwilę.');  
            }
        });
    }


    return (
        <>
            <header className="header">
                <div className="header__image-box">
                    <a href="">
                        <img
                            src={logo_pop}
                            alt="Logo Egurrola Dance Studio"
                            className="header__image"
                        />
                    </a>
                </div>
                <div className="header__caption-box">
                    <span className="header__caption">
                        Proces zakupu kursu: {localStorage.getItem('courseHeadingName')}
                    </span>
                </div>
            </header>
            <div className="content">
                <a href="#">
                    <Link to="/wybor_opcji_1_uczestnik">
                        <img src={arrow_back} alt="arrow_back" className="arrow-back" />
                    </Link>
                </a>
                <ProfileHeader></ProfileHeader>
                <aside className="registration-steps margin-top-32">
                    <div className="step">
                        <div className="step__circle step__circle--active">
                            <span className="step__count">1</span>
                        </div>
                        <span className="step__text">Wybór&nbsp;kursu</span>
                    </div>
                    <div className="step">
                        <div className="step__circle">
                            <span className="step__count">2</span>
                        </div>
                        <span className="step__text">Umowa</span>
                    </div>
                    <div className="step">
                        <div className="step__circle">
                            <span className="step__count">3</span>
                        </div>
                        <span className="step__text">Płatność</span>
                    </div>
                </aside>
                <aside className="registration-course-steps margin-top-16">
                    <span className="step">Uczestnik</span>
                    <div className="hyphen"></div>
                    <span className="step step--active">Data</span>
                    <div className="hyphen"></div>
                    <span className="step">Wariant</span>
                    <div className="hyphen"></div>
                    <span className="step">Forma płatności i rabat</span>
                    <div className="hyphen"></div>
                    <span className="step">Raty</span>
                </aside>
                <main className="responsive-padding">
                    <section className="course-options-date margin-top-64">
                        {!coursesHeadings ? (
                            ''
                        ) : (
                            <div>
                                <h2 className="h2">WYBRAŁEŚ KURS</h2>
                                <p
                                    id="purchased-title"
                                    className="purchased__title h3 margin-top-32"
                                >
                                    {coursesHeadings.courseHeadingName},{' '}
                                    {coursesHeadings.courseLevel}, styl:{' '}
                                    {coursesHeadings.courseDanceStyle}
                                </p>
                                <p>czas zajęć: {coursesHeadings.DurationMin + ' min'}</p>
                                <p>w tygodniu: {coursesHeadings.Frequency}</p>
                                <ul id="related-list">
                                    {res.map((el) => (
                                        <p>{el.name}</p>
                                    ))}
                                </ul>
                            </div>
                        )}
                        <div className="margin-top-32"></div>
                        <h2 className="h2">Data rozpoczęcia</h2>
                        <form
                            id="course-options-date-form"
                            className="margin-top-32"
                            method="post"
                            action=""
                            
                        >
                            <h3 className="h3">Od kiedy chesz zacząć?</h3>
                            <div className="form__row margin-top-16">
                                <label htmlFor="startdate" className="form__label">
                                    Data (DD.MM.RRRR)<sup> *</sup>
                                </label>
                                <input
                                    type="date"
                                    name="startdate"
                                    id="startdate"
                                    className="form__input"
                                    title="Kiedy zaczynamy"
                                    defaultValue={defaultValue}
                                    // value={useState.startDate}
                                    onChange={(e) => {
                                        setFromData({
                                            ...formData,
                                            ...{ startDate: e.target.value },
                                        });
                                        setSelectedItem(1);
                                        dispatch(setGroups(''));
                                    }}
                                    required
                                />
                            </div>
                            <input
                               onClick={(e) => {
                                goNextStaps(e);
                            }}
                                type="button"
                                className={`btn-primary margin-top-64 margin-bottom-32 
                                ${( disableButton ) ? 'button-disabled' : '' }
                               `}
                                value="Dalej"
                            />
                        </form>
                    </section>
                </main>
            </div>
            <EDSFooter></EDSFooter>
        </>
    );
};
export default Wybor_opcji_2_data;
